export default __webpack_public_path__ + "static/media/openxtoolbox-logo.a9f8fef9.svg";